
export default {
  name: 'CalorieCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What's the best calorie-tracking app?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Some utterly free calorie counter apps you can use to track calories are MyFitnessPal and Lose It. Chronometer offers several features to aid your goals if you're on a special diet. Meanwhile, if you want to build healthy eating and living habits, consider trying Lifesum."
        }
      },{
        "@type": "Question",
        "name": "Do I need to count calories for weight gain or loss?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cutting calories into your body compared to your usual routine will help you lose fat. The smartest choice is to use protein-rich foods and divide your meals throughout the day. Meanwhile, limit your intake of energy-rich foods as much as possible."
        }
      },{
        "@type": "Question",
        "name": "How should I count and track my calories and macros?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "There are many free macro tracking apps you can use these days. Alternatively, you can also use a digital food scale to track macros."
        }
      },{
        "@type": "Question",
        "name": "What food is high in calories?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Foods that provide many calories are often rich in protein and carbohydrates. The most calorie-dense foods are probably red meat, grilled chicken, oily fish, and full-fat yogurt."
        }
      },{
        "@type": "Question",
        "name": "What food burns the most calories?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Eggs are one of the best calorie-burning foods. It contains high-quality protein, which speeds up metabolism. It is also why you feel full right after eating a few eggs."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        age: 25,
        gender: 'male',
        unit: 'metric',
        height_metric: 175,
        weight_metric: 70,
        height_us_feet: 5,
        height_us_inch: 10,
        weight_us: 160,
        level: 1.465
      })
    }
  },
  methods: {
    onCalorieCalculator() {
        this.form.post(`/tool/calorie-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
